import * as Sentry from '@sentry/react'
import type { AnyRouter } from '@tanstack/react-router'

export function initSentry(router: AnyRouter) {
  const dsn = import.meta.env.VITE_SENTRY_DSN

  if (!dsn) {
    return
  }

  Sentry.init({
    dsn,
    enabled: true,
    environment: import.meta.env.MODE,
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    initialScope: {
      tags: { platform: 'frontend' },
    },
  })
}

export { Sentry }
